import moment from 'moment'

export function isValidDate(date) {
  return !(date === undefined || date === null || !moment(date).isValid());
}

export function convertDateTimeFromServer(date) {
  if (date) {
    return new Date(date);
  } else {
    return null;
  }
}


 //Subtracts number of years from the input date
 export function getDateFromYearsToSubtract(date, noOfYearsToSubtract){
  return moment(date).add(noOfYearsToSubtract*-1, 'years');
}

export function convertLocalDateFromServer(date) {
  if (date) {
    var dateString = date.split("-");
    return new Date(dateString[0], dateString[1] - 1, dateString[2]);
  }
  return null;
}


export  function convertLocalDateFromServerDate(date){
  if (date) {
       return new Date(convertDateToString(date, serverDateFormat));
    }
  return null;
}





export  function convertDateStringToMoventDate(date){
  if (date) {
        //var dateString = date.split('-');
        var formatedDate=  moment(date).format(serverDateFormat);
        return formatedDate;
      // return new Date(date);
    }
  return null;
}


export  function convertDateToMoventDate(date){
  if (date) {
        var formatedDate=  moment(date);
        return formatedDate;
      // return new Date(date);
    }
  return null;
}


export function getMinDate(date) {
  var minDate = new Date("1900-01-01");
  if(isValidDate(date)) {
      minDate = date;
  }
  return convertLocalDateFromServerDate(minDate);
}

export function getMaxDate(date) {
  var maxDate = new Date("9999-12-31");
  if(isValidDate(date)) {
      maxDate = date;
  }
  return convertLocalDateFromServerDate(maxDate);
}

export  function convertDateToString(date,formatString){
  if (date) {
        return  moment(date).format(formatString);      
    }
  return null;
}


export const serverDateFormat="YYYY-MM-DD";